/* ============================================================
   LP Master — landing page engine
   Loaded once per page via snippets/lp-master-head.liquid.
   Kaching note: this file no longer reads, watches or touches the
   Kaching widget in any way. Kaching owns the offer UI entirely.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- IDEMPOTENCE GUARD ----------
     Every lp-* section renders 'lp-master-head', so this file's <script>
     tag can appear many times on one page. The guard makes sure handlers
     bind only once. */
  if (window.__lpMasterInit) return;
  window.__lpMasterInit = true;

  /* Countdown is owned by the lp-close section, read via a page-scoped
     global it emits. */
  var COUNTDOWN_ENABLED = false;
  var COUNTDOWN_END = null;

  (function () {
    var c = window.__lpCloseCountdown || {};
    COUNTDOWN_ENABLED = !!c.enabled;
    COUNTDOWN_END = c.end || null;
  })();

  /* ---------- STICKY ADD TO CART ----------
     The sticky bar button submits the same ATF form Kaching writes its
     selection into, so both buttons always add the same thing. */
  var stickyAtcBtn = document.getElementById('stickyAtc');
  if (stickyAtcBtn) {
    stickyAtcBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var form = document.getElementById('kaching-atf-form');
      if (!form) return;
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        var atcBtn = document.getElementById('atc');
        if (atcBtn) atcBtn.click();
      }
    });
  }

  /* ---------- 5. GALLERY ---------- */
  var track = document.getElementById('galTrack');
  var thumbs = document.getElementById('galThumbs');
  var galPrev = document.getElementById('galPrev');
  var galNext = document.getElementById('galNext');
  var galNowEl = document.getElementById('galNow');
  var galTotalEl = document.getElementById('galTotal');
  var slides = track ? track.children : [];
  var galIdx = 0;

  if (galTotalEl) galTotalEl.textContent = slides.length;

  function goGal(i) {
    if (!track || !slides.length) return;
    galIdx = (i + slides.length) % slides.length;
    track.style.transform = 'translateX(' + (-galIdx * 100) + '%)';
    if (galNowEl) galNowEl.textContent = galIdx + 1;
    if (thumbs) {
      Array.prototype.forEach.call(thumbs.children, function (el, idx) {
        el.setAttribute('aria-current', String(idx === galIdx));
      });
    }
  }

  if (track && slides.length > 1) {
    if (thumbs) {
      Array.prototype.forEach.call(slides, function (img, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-current', String(i === 0));
        b.setAttribute('aria-label', 'Show image ' + (i + 1));
        var thumbSrc = img.getAttribute('src') || img.currentSrc || '';
        try {
          var thumbUrl = new URL(thumbSrc, window.location.origin);
          thumbUrl.searchParams.set('width', '160');
          thumbSrc = thumbUrl.toString();
        } catch (err) {
          // Fall back to the existing image source.
        }
        b.innerHTML = '<img src="' + thumbSrc + '" alt="" loading="lazy" width="80" height="80">';
        b.addEventListener('click', function () { goGal(i); });
        thumbs.appendChild(b);
      });
    }
    if (galPrev) galPrev.addEventListener('click', function () { goGal(galIdx - 1); });
    if (galNext) galNext.addEventListener('click', function () { goGal(galIdx + 1); });

    var gx0 = null;
    var stage = track.parentNode;
    stage.addEventListener('touchstart', function (e) { gx0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (gx0 === null) return;
      var dx = e.changedTouches[0].clientX - gx0;
      if (Math.abs(dx) > 40) goGal(galIdx + (dx < 0 ? 1 : -1));
      gx0 = null;
    });
  }

  /* ---------- 6. CAROUSELS ---------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-carousel]'), function (root) {
    var trk = root.querySelector('.lpm-carousel__track');
    if (!trk) return;
    var items = trk.children;
    var dotsEl = root.querySelector('[data-dots]');
    var navEl = root.querySelector('.lpm-carousel__nav');
    var viewport = root.querySelector('.lpm-carousel__viewport');
    var idx = 0;

    function perView() {
      if (!items.length || !viewport) return 1;
      var w = items[0].getBoundingClientRect().width;
      if (!w) return 1;
      return Math.max(1, Math.round(viewport.getBoundingClientRect().width / w));
    }
    function pages() { return Math.max(1, items.length - perView() + 1); }

    function drawDots() {
      if (navEl) navEl.style.display = pages() <= 1 ? 'none' : '';
      if (!dotsEl) return;
      dotsEl.innerHTML = '';
      for (var i = 0; i < pages(); i++) {
        (function (i) {
          var d = document.createElement('button');
          d.type = 'button';
          d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          d.setAttribute('aria-current', String(i === idx));
          d.addEventListener('click', function () { go(i); });
          dotsEl.appendChild(d);
        })(i);
      }
    }
    function go(i) {
      var p = pages();
      idx = (i + p) % p;
      trk.style.transform = 'translateX(' + (-idx * (100 / perView())) + '%)';
      if (dotsEl) {
        Array.prototype.forEach.call(dotsEl.children, function (el, k) {
          el.setAttribute('aria-current', String(k === idx));
        });
      }
    }
    var prevBtn = root.querySelector('[data-prev]');
    var nextBtn = root.querySelector('[data-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { go(idx - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(idx + 1); });

    var x0 = null;
    trk.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    trk.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1));
      x0 = null;
    });

    drawDots(); go(0);
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { idx = 0; drawDots(); go(0); }, 150);
    });
  });

  /* ---------- 7. ACCORDIONS ---------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-acc]'), function (acc) {
    Array.prototype.forEach.call(acc.querySelectorAll('.lpm-acc__btn'), function (btn) {
      var panel = btn.nextElementSibling;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        Array.prototype.forEach.call(acc.querySelectorAll('.lpm-acc__btn'), function (b) {
          b.setAttribute('aria-expanded', 'false');
          if (b.nextElementSibling) b.nextElementSibling.style.maxHeight = null;
        });
        if (!open && panel) {
          btn.setAttribute('aria-expanded', 'true');
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  });

  /* ---------- 8. COUNTDOWN ---------- */
  (function () {
    var box = document.getElementById('countdown');
    if (!box) return;
    if (!COUNTDOWN_ENABLED || !COUNTDOWN_END) { box.remove(); return; }

    var end = Date.parse(COUNTDOWN_END);
    if (isNaN(end)) {
      console.warn('LP Master: countdown deadline is not a valid date —', COUNTDOWN_END);
      box.remove();
      return;
    }
    if (end <= Date.now()) { box.remove(); return; }

    var h = document.getElementById('cdH'), m = document.getElementById('cdM'), s = document.getElementById('cdS');
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var left = end - Date.now();
      if (left <= 0) { box.remove(); clearInterval(timer); return; }
      var t = Math.floor(left / 1000);
      h.textContent = pad(Math.floor(t / 3600));
      m.textContent = pad(Math.floor((t % 3600) / 60));
      s.textContent = pad(t % 60);
    }
    box.hidden = false;
    tick();
    var timer = setInterval(tick, 1000);
  })();

  /* ---------- 9. STICKY BAR ---------- */
  /* Shows the sticky bar once the main Add to Cart scrolls off screen.
     The price slot is hidden: it used to be filled by reading the Kaching
     widget, which has been removed so nothing interferes with Kaching. */
  (function () {
    var bar = document.getElementById('stickybar');
    var anchor = document.getElementById('atc');
    if (!bar || !anchor) return;

    var priceBox = bar.querySelector('.lpm-stickybar__price');
    if (priceBox) priceBox.style.display = 'none';

    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('lpm-show', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(anchor);
  })();

})();